import { render, staticRenderFns } from "./TqLoaderButton.vue?vue&type=template&id=60509edd&scoped=true&"
import script from "./TqLoaderButton.vue?vue&type=script&lang=js&"
export * from "./TqLoaderButton.vue?vue&type=script&lang=js&"
import style0 from "./TqLoaderButton.vue?vue&type=style&index=0&id=60509edd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60509edd",
  null
  
)

export default component.exports